export const updateBonusAction = `mutation UpdateBonus($input: UpdateBonusInput!) {
    updateBonus(input: $input) {
        id
        amountDue
        bonusStatus
        companyId
        contactId
        contact {
            emailAddress
            firstName
            lastName
        }
        currency
        earnedDate
        hireDate
        jobId
        job {
            externalJobId
            id
            referralBonus
            title
        }
        notes
        paidDate
        payment
        recipientType
        referralId
        startDate
        userId
        user {
            id
            accountClaimId
            accountClaim{
            id
            }
            emailAddress
            firstName
            lastName
            userGroupId
            userGroup {
            id
            }
        }
        ignoreEligibilityChecks
    }
  }
  `;
